import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const toggleInvoiceRefund = {
  name: "toggleInvoiceRefund" as const,
  input: z.object({
    teamId: zExt.objectId(),
    invoiceId: zExt.objectId(),
    refunded: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
